import React, { PureComponent } from 'react';
import { Grid, Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form/immutable';
import parse from 'html-react-parser';
import {
  isValidPhoneNumber,
  isValidEmail,
  isNotSamePhoneNumber,
  normalizePhoneNumberRedesign,
  isValidNANPPhoneNumber,
} from '../../common/validation';
import CalenderPro from './CalenderPro.js';
import AppointmentSlots from './AppointmentSlots';
import AppointmentReminder from './AppointmentReminder';
import { getTwoDigitDateNonUTC, getTwoDigitMonthNonUTC } from '../../../utils/CalenderUtils';
import SpecialInstruction from './SpecialInstruction';
import { Title, Body } from '../../common/Typography/index';
import { goToProcessStep } from '../../../redirection';
import { getAPPID, isMobile, getSession, isLoggedIn, phoneNumberValidationCheck, isExpressCheckout } from '../../common/Helpers';
import { eventDispatcher } from '../../common/Tagging/index';
import { store } from '../../../configureStore';
import ConsentMessage from './ConsentMessage.js';

class AppointmentCalenderProVds extends PureComponent {
  constructor(props) {
    super(props);
    const currentMonth = props?.appointmentScheduleResponse && props?.appointmentScheduleResponse?.startDate;
    const apptStartMonth =
      props?.appointmentScheduleResponse &&
      props?.appointmentScheduleResponse?.apptAvailableDays &&
      props?.appointmentScheduleResponse?.apptAvailableDays[0]
        ? props.appointmentScheduleResponse?.apptAvailableDays[0]?.date
        : null;

    let defaultDate = null;
    if (props.appointmentScheduleResponse.apptAvailableDays && props.appointmentScheduleResponse.apptAvailableDays.length > 0) {
      if (
        props?.appointmentScheduleResponse &&
        props.appointmentScheduleResponse?.apptUnavailableDays &&
        !props.appointmentScheduleResponse?.apptUnavailableDays?.includes(props.appointmentScheduleResponse?.apptAvailableDays[0]?.date)
      ) {
        defaultDate = props.appointmentScheduleResponse.apptAvailableDays[0].date;
      }
    }
    this.state = {
      isSlotSelected: null,
      selectedDay: null,
      isFieldVisible: false,
      selectedDate: defaultDate,
      showOutOfTimeFrame: currentMonth !== apptStartMonth,
      isReminderSpecInstVisible: true,
      phoneError: '',
      emailError: '',
      isReminderChoosen: false,
      email: '',
      existEmail: '',
      isEmailValueAltered: false,
      isNonVZPhoneNumber: false,
      enableCheckbox: false,
      enableNonVZckbox: false,
      reminderTypeLocal: 'Call',
    };
    props.appointmentCTA(true);

    props.saveSelectedDate(defaultDate, null);
    props.saveSpecInstrc('');
  }

  componentDidMount() {
    const emailId =
      this.props.cartDetails &&
      this.props.cartDetails?.primaryUserInfo &&
      this.props.cartDetails?.primaryUserInfo.address &&
      this.props.cartDetails?.primaryUserInfo?.address?.emailId
        ? this.props.cartDetails?.primaryUserInfo?.address?.emailId
        : '';
    const phoneNumber =
      this.props.cartDetails &&
      this.props.cartDetails?.primaryUserInfo &&
      this.props.cartDetails.primaryUserInfo?.address &&
      this.props.cartDetails.primaryUserInfo.address?.phoneNumber
        ? this.props.cartDetails.primaryUserInfo.address.phoneNumber
        : '';

    this.props.saveEmailId(emailId, false);
    this.setState({ existEmail: emailId, email: emailId });
    this.props.savePhoneNumber(phoneNumber, false);
    this.addEmailTooltipClickListener();
    this.props.setEmailValidationdata({});
    this.props.invokeTaggingAPI();
    this.setState({ enableNonVZckbox: this.props?.isNonVzConsentCheckboxChecked });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState?.selectedDay?.getDate() !== this.state.selectedDay?.getDate()) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSlotSelected: false,
      });
    } else if (this.state.selectedDay && this.state.isSlotSelected && prevState?.selectedDay?.getDate() === this.state.selectedDay?.getDate()) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSlotSelected: true,
      });
    }

    if (prevProps !== this.props || prevState !== this.state) {
      this.addEmailTooltipClickListener();
    }
    if (
      (prevProps.emailMaxAttempts !== this.props.emailMaxAttempts && this.props.emailMaxAttempts) ||
      (prevProps.isEmailSuccess !== this.props.isEmailSuccess &&
        (this.props.isEmailSuccess?.valid === 'Manual_validation' ||
          this.props.isEmailSuccess?.valid === 'Fake' ||
          this.props.isEmailSuccess?.valid === 'Invalid' ||
          this.props.isEmailSuccess?.valid === 'false'))
    ) {
      this.setState({ emailError: 'Please enter a valid email' });
    }

    if (prevProps.isEmailSuccess !== this.props.isEmailSuccess || prevProps.emailMaxAttempts !== this.props.emailMaxAttempts) {
      this.isEmailRevalidationSuccess();
    }

    if (prevProps.phoneAPiResponse !== this.props.phoneAPiResponse) {
      const isNonVZPhoneNumber =
        phoneNumberValidationCheck() &&
        this.props?.phoneAPiResponse?.data?.wireless === true &&
        ((this.props?.phoneAPiResponse?.data?.vzSpid !== undefined &&
          this.props?.phoneAPiResponse?.data?.vzSpid === false &&
          ((this.props?.phoneAPiResponse?.data?.consentInfo !== undefined && !this.props?.phoneAPiResponse?.data?.consentInfo) ||
            (this.props?.phoneAPiResponse?.data?.consentInfo !== undefined &&
              !this.props?.phoneAPiResponse?.data?.consentInfo?.purposes?.some((purpose) => purpose?.status === 'ACTIVE')))) ||
          (this.props?.phoneAPiResponse?.data?.vzSpid === false && !this.props?.phoneAPiResponse?.data?.consentInfo));
      this.setState({ isNonVZPhoneNumber });
      if (isNonVZPhoneNumber) {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar13: 'SMS Consent Displayed non vz users',
          },
        });
      }
    }
  }

  addEmailTooltipClickListener = () => {
    const emailLinkObj = document.getElementById('emailVal');
    if (emailLinkObj) {
      const obj = {
        name: '',
        svars: {
          evar13: 'Click here to validate your email address',
        },
      };
      eventDispatcher('sendData', obj);
      emailLinkObj.style.color = 'black';
      emailLinkObj.style.textDecoration = 'underline';
      emailLinkObj.style.cursor = 'pointer';
      emailLinkObj.addEventListener('click', (event) => {
        event.preventDefault();
        emailLinkObj.setAttribute('pointer-events', 'none');
        emailLinkObj.setAttribute('cursor', 'not-allowed');
        const LQResponseData = getSession('LQResponse') ? JSON.parse(getSession('LQResponse')) : '';
        if (LQResponseData) {
          const postData = {};
          if (isLoggedIn()) {
            postData.mtn = LQResponseData?.output?.loginMtn;
          }
          postData.email = this.state.email;
          this.props.accMainEmailAppointmentVerify(postData);
        }
      });
    }
  };

  emailConfirm = (event, id) => {
    event.preventDefault();
    this.props.emailVaildationAppointmentAPI(this.state.email, id);
    const obj = {
      name: '',
      svars: {
        evar13: 'Please check your email. After validating your email address, click on confirm below',
      },
    };
    eventDispatcher('sendData', obj);
  };

  redirection = () => {
    if (getAPPID() === 'NSE') {
      this.goToNextStepInNSEFlow();
    } else if (isExpressCheckout()) {
      goToProcessStep(this.props.currentView.TOSROUTE, this.props.history);
    } else {
      goToProcessStep(this.props.currentView, this.props.history);
    }
  };

  handleReminder = (reminderType) => {
    this.setState({
      isFieldVisible: true,
      reminderTypeLocal: reminderType,
    });
    let CTAdisabled = false;
    const phoneNo =
      this.props?.appointmentScheduleState && this.props?.appointmentScheduleState?.phoneNumberR
        ? this.props?.appointmentScheduleState?.phoneNumberR
        : null;

    const emailId =
      this.props.appointmentScheduleState && this.props.appointmentScheduleState.emailIdR ? this.props.appointmentScheduleState.emailIdR : null;
    if (reminderType === 'Email') {
      if (emailId === '' || emailId === null) {
        CTAdisabled = true;
      }
      if (emailId !== '' && emailId !== null && !isValidEmail(emailId)) {
        CTAdisabled = true;
      }
    } else {
      if (phoneNo === '' || phoneNo === null) {
        CTAdisabled = true;
      }
      if (phoneNo !== '' && phoneNo !== null && !isValidPhoneNumber(this.unParseNumber(phoneNo.trim()))) {
        CTAdisabled = true;
      }
    }
    this.props.saveCTAdisabled(CTAdisabled);
    this.props.appointmentCTA(true);
    this.props.saveReminderType(reminderType);
  };

  onSpecialInstructionChange = (e) => {
    const val = e.target.value.trim();

    this.props.saveSpecInstrc(val);
  };

  handleDayClick = (day, modifiers = {}) => {
    const formattedDay = new Date(day);
    if (modifiers.disabled || modifiers.selected) {
      return;
    }
    const dateString = `${formattedDay.getUTCFullYear()}${getTwoDigitMonthNonUTC(formattedDay)}${getTwoDigitDateNonUTC(formattedDay)}`;
    this.setState({
      selectedDay: modifiers.selected ? undefined : formattedDay,
      selectedDate: dateString,
      showOutOfTimeFrame: false,
    });
    this.props.saveSelectedDate(dateString, modifiers.selected ? undefined : formattedDay);
    if (this.state.selectedDate !== dateString) {
      // ACT145-844 - while choosing selected date from calender slots not getting pre-selected
      this.props.saveSelectedSlot(null);
    }
  };

  handleSlotSelection = (selectedSlot) => {
    this.setState({
      isSlotSelected: true,
      isFieldVisible: true,
    });
    this.props.appointmentCTA(true);
    this.props.saveSelectedSlot(selectedSlot && JSON.parse(selectedSlot));
  };

  unParseNumber = (number) => {
    let unParsedNumber = null;
    if (number) {
      unParsedNumber = number.replace(/\./g, '');
    }
    return unParsedNumber;
  };

  onEmailChange = (e) => {
    const val = e.target.value;
    let error = false;
    if (val === '') {
      error = true;
    }
    if (val !== '' && !isValidEmail(val)) {
      error = true;
    }
    if (error) {
      this.setState({ emailError: 'Please enter a valid email addres' });
    }
    if (!error) {
      this.setState({ emailError: '' });
    }
    this.setState({ email: val, isEmailValueAltered: true });

    // if email changes then revalidate it.
    const CTAdisabled = true;
    this.props.saveEmailId(val, CTAdisabled);
  };

  onPhoneNumberChange = (e) => {
    const val = e?.target?.value?.replace(/([^\w ]|_)/g, '')?.trim() || '';
    const phoneErrorText = 'Please enter a valid phone number.';
    let CTAdisabled = false;
    const parsedNumber = this.unParseNumber(val);
    const isInvalidPhoneNumber = !isValidPhoneNumber(parsedNumber);
    const normalizePhoneNumber = normalizePhoneNumberRedesign(val.trim());
    const isInvalidNANPPhoneNumber = isValidNANPPhoneNumber(normalizePhoneNumber);

    if (
      !val ||
      isInvalidPhoneNumber ||
      parsedNumber.length !== 10 ||
      parsedNumber === '0000000000' ||
      parsedNumber === '9999999999' ||
      isNotSamePhoneNumber(val.trim())
    ) {
      this.setState({ phoneNumber: '', phoneError: phoneErrorText });
      CTAdisabled = true;
    } else if (isInvalidNANPPhoneNumber) {
      this.setState({ phoneNumber: '', phoneError: phoneErrorText });
      CTAdisabled = true;
    } else {
      this.setState({ phoneNumber: val, phoneError: '' });
      CTAdisabled = false;
      if (phoneNumberValidationCheck() && this.state.reminderTypeLocal === 'Call') {
        this.props.phoneVaildationAPI(parsedNumber);
      }
    }
    this.props.savePhoneNumber(this.unParseNumber(val.trim()), CTAdisabled);
  };

  handleNonVzCheckbox = (e) => {
    e.preventDefault();
    let checkBoxNewState;
    if (e.keyCode === 32 || e.keyCode === 13) {
      this.setState((prevState) => {
        checkBoxNewState = !prevState.enableNonVZckbox;
        return {
          enableNonVZckbox: checkBoxNewState,
        };
      });
    } else {
      checkBoxNewState = e.target.checked;
      this.setState({
        enableNonVZckbox: checkBoxNewState,
      });
    }
    store.dispatch({ type: 'NON_VZ_CHECKBOX_VALUE', payload: checkBoxNewState });
  };

  goToNextStepInNSEFlow = (...args) => {
    if (this.props.isUniversalProfileCreated || this.props.isEmailExists) {
      this.byPassRegistrationStep(...args);
    } else {
      goToProcessStep(this.props.currentView.NSE, this.props.history, ...args);
    }
  };

  isEmailRevalidationSuccess = () => {
    if (!this.state.isEmailValueAltered) {
      this.props.saveEmailId(this.state.email, false);
      return;
    }

    const { isEmailSuccess, emailMaxAttempts } = this.props;
    const isCTAdisabled = !(
      (isEmailSuccess?.valid === 'Valid' || isEmailSuccess?.valid === 'White_listed' || isEmailSuccess?.valid === 'true') &&
      !emailMaxAttempts
    );

    this.props.saveEmailId(this.state.email, isCTAdisabled);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.appointmentScheduleState.skipOrderWriteEtos !== nextProps.appointmentScheduleState.skipOrderWriteEtos && isExpressCheckout()) {
      this.redirection();
    }
    if (this.props.appointmentScheduleState.isSubmitSuccess !== nextProps.appointmentScheduleState.isSubmitSuccess) {
      this.redirection();
    }
  }

  render() {
    const { isEmailSuccess, accMainEmailVal, emailMaxAttempts } = this.props;
    let emailBannerSubtitle;
    const emailBannerTitle = this.props?.contact_info_email_validation_banner_text_desktop?.split('<br>')[0];
    emailBannerSubtitle = this.props?.contact_info_email_validation_banner_text_desktop?.split('<br>')[1];
    const emailBannerConfirmText = this.props?.contact_info_email_validation_banner_text_desktop?.split('<br>')[2];
    emailBannerSubtitle = emailBannerSubtitle?.replace('<email address>', this.state.email);
    const validateEmailResponse = this.props?.isEmailSuccess?.valid;
    if (this.props?.appointmentScheduleState && this.props?.appointmentScheduleState?.reminderTypeR === 'Email') {
      if (validateEmailResponse === 'Valid' || validateEmailResponse === 'White_listed' || validateEmailResponse === 'true') {
        this.setState({ emailError: false, manualValidation: false });
      } else if (validateEmailResponse === 'Fake' || validateEmailResponse === 'Invalid' || validateEmailResponse === 'false') {
        this.setState({ emailError: true, manualValidation: false });
        this.props.saveEmailId(this.state.email.trim(), true);
      } else if (validateEmailResponse === 'Manual_validation') {
        this.setState({ emailError: true, manualValidation: true });
        this.props.saveEmailId(this.state.email.trim(), true);
      }
    }
    const { isNonVZPhoneNumber } = this.state;

    return (
      <React.Fragment>
        <Grid>
          <Row className={`noPadding ${isMobile() ? 'marginBottom40' : 'marginBottom48'}`}>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 11 }} className="noPadding">
              <Title primitive="h1" size="XLarge">
                {isMobile() ? parse(this.props.headingRedesignMobile) : parse(this.props.headingRedesign)}
              </Title>
              <div className="marginTop12">
                <Body primitive="p" color="#6F7171" size="large">
                  {this.props.subHeading}
                </Body>
              </div>
            </Col>
          </Row>
          <Row id="appointmentCalender" analyticstrack="5G-appointmentCalender" className="noPadding">
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 13 }} className="noPadding">
              <div className="marginBottom24">
                <Title primitive="p" size="medium">
                  {this.props.calenderHeading}
                </Title>
              </div>
              <CalenderPro
                // cqContent={cqContent}
                schedulingDetails={this.props.appointmentScheduleResponse}
                selectedDay={this.state.selectedDay}
                handleDayClick={this.handleDayClick}
                disableDates={this.state.showOutOfTimeFrame}
                hideFooterNote
                calenderLabel={this.props.calenderLabel}
              />

              <AppointmentSlots
                handleSlotSelection={this.handleSlotSelection}
                selectedSlot={this.props.appointmentScheduleState && this.props.appointmentScheduleState.selectedSlotR}
                slotsHeading={this.props.slotsHeading}
                slotsSubHeading={this.props.slotsSubHeading}
                availableSlots={this.props.appointmentScheduleResponse.apptAvailableDays.filter((slot) => slot.date === this.state.selectedDate)[0]}
                saveSelectedSlot={this.props.saveSelectedSlot}
                selectedDate={this.state.selectedDate}
              />
            </Col>
          </Row>
          <Row className="onlyBottomPad">
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 9 }} className="noPadding marginTop30">
              <Body primitive="p" size="large">
                {this.props.appointmentReminderText}
              </Body>
              <AppointmentReminder
                emailBannerTitle={emailBannerTitle}
                emailBannerSubtitle={emailBannerSubtitle}
                emailBannerConfirmText={emailBannerConfirmText}
                manualValidation={this.state.manualValidation}
                // cqContent={cqContent}
                handleReminder={this.handleReminder}
                isFieldVisible={this.state.isFieldVisible}
                // reminderCtaEnabled={this.state.showCTA}
                orderCall={this.orderCall}
                // selectedPhone={!this.props.selectedPhone ? schedulingDetails.phoneNumber : this.props.selectedPhone}
                defaultEmail={this.props.appointmentScheduleState && this.props.appointmentScheduleState.emailIdR}
                email={this.state.email}
                existEmail={this.state.existEmail}
                contactNumber={this.props.appointmentPhoneNumber}
                phoneNumber={this.props.appointmentScheduleState && this.props.appointmentScheduleState.phoneNumberR}
                // completeOrder={this.completeOrder}
                onPhoneNumberChange={this.onPhoneNumberChange}
                phoneError={this.state?.phoneError}
                onSuccess={this.state?.phoneNumber && !this.state.phoneError}
                emailError={this.state.emailError}
                onEmailChange={this.onEmailChange}
                reminderType={this.props.appointmentScheduleState && this.props.appointmentScheduleState.reminderTypeR}
                isReminderChoosen={this.state.isReminderChoosen}
                isEmailSuccess={isEmailSuccess}
                accMainEmailVal={accMainEmailVal}
                emailMaxAttempts={emailMaxAttempts}
                emailAPICall={this.props.emailVaildationAppointmentAPI}
                contactEditProps={this.props}
                accMainEmailVerify={this.props.accMainEmailAppointmentVerify}
                emailConfirm={this.emailConfirm}
                setEmailValidationdata={this.props.setEmailValidationdata}
                appointment_email_legal={this.props.appointment_email_legal}
                isValidEmail={isValidEmail(this.state.email)}
              />
            </Col>

            {isNonVZPhoneNumber && this.state.phoneError === '' && this.state.reminderTypeLocal === 'Call' ? (
              <ConsentMessage
                enableNonVZckbox={this.state?.enableNonVZckbox}
                enableCheckbox={this.state?.enableCheckbox}
                handleNonVzCheckbox={this.handleNonVzCheckbox}
                contact_info_contact_send_offer={this.props.contact_info_contact_send_offer}
                contact_info_contact_nonVz_send_offer={this.props?.contact_info_contact_nonVz_send_offer}
              />
            ) : (
              <></>
            )}
          </Row>
        </Grid>

        <SpecialInstruction
          cqContent={this.props.cqContent}
          isReminderSpecInstVisible={this.state.isReminderSpecInstVisible}
          onSpecialInstructionChange={this.onSpecialInstructionChange}
          specInstructionValue={this.props.appointmentScheduleState && this.props.appointmentScheduleState.specialInstructionValue}
          specialInstructionsSubHeading={this.props.specialInstructionsSubHeading}
          specialInstructionsHeading={this.props.specialInstructionsHeadingRedesign}
          specialInstructionsText={this.props.specialInstructionsText}
        />
      </React.Fragment>
    );
  }
}
AppointmentCalenderProVds.propTypes = {
  invokeTaggingAPI: PropTypes.func,
  appointmentReminderText: PropTypes.string,
  cqContent: PropTypes.string,
  specialInstructionsSubHeading: PropTypes.string,
  specialInstructionsText: PropTypes.string,
  slotsHeading: PropTypes.string,
  slotsSubHeading: PropTypes.string,
  appointmentScheduleState: PropTypes.string,
  currentView: PropTypes.string,
  history: PropTypes.string,
  headingRedesign: PropTypes.string,
  subHeading: PropTypes.string,
  appointmentScheduleResponse: PropTypes.array,
  cartDetails: PropTypes.array,
  appointmentPhoneNumber: PropTypes.string,
  headingRedesignMobile: PropTypes.string,
  calenderLabel: PropTypes.string,
  calenderHeading: PropTypes.string,
  appointmentCTA: PropTypes.func,
  saveSelectedDate: PropTypes.func,
  saveReminderType: PropTypes.func,
  saveSelectedSlot: PropTypes.func,
  saveEmailId: PropTypes.func,
  savePhoneNumber: PropTypes.func,
  saveSpecInstrc: PropTypes.func,
  specialInstructionsHeadingRedesign: PropTypes.any,
  saveCTAdisabled: PropTypes.func,
  isEmailSuccess: PropTypes.string,
  accMainEmailVal: PropTypes.string,
  emailMaxAttempts: PropTypes.string,
  emailVaildationAppointmentAPI: PropTypes.func,
  accMainEmailAppointmentVerify: PropTypes.func,
  contact_info_email_validation_banner_text_desktop: PropTypes.string,
  setEmailValidationdata: PropTypes.func,
  appointment_email_legal: PropTypes.string,
  isUniversalProfileCreated: PropTypes.bool,
  isEmailExists: PropTypes.bool,
  phoneVaildationAPI: PropTypes.func,
  contact_info_contact_send_offer: PropTypes.string,
  contact_info_contact_nonVz_send_offer: PropTypes.string,
  phoneAPiResponse: PropTypes.any,
  isNonVzConsentCheckboxChecked: PropTypes.bool,
  reminderTypeR: PropTypes.string,
};

export default reduxForm({
  form: 'appointmentSchedule',
  // validate,
  // asyncValidate,
  asyncBlurFields: ['phoneDetails'],
  enableReinitialize: true,
  destroyOnUnmount: false,
})(AppointmentCalenderProVds);
